import { useState } from "react";
import * as S from "./style";
import SelectedPub from "./components/selected-pub";
import useLogin from "./hook/use-login";

const Login = () => {
  const [pwView, setPwView] = useState(false);
  const {
    textId,
    setTextId,
    password,
    setPassword,
    handleSellerLogin,
    pubOwners,
    handleNaverLogin,
    handleAppleLogin,
  } = useLogin();

  if (pubOwners.length > 0) {
    return <SelectedPub pubOwners={pubOwners} />;
  }

  return (
    <S.Wrapper>
      <S.LoginLeftWrapper>
        <S.LoginLeftContentWrapper>
          <img src="/image-web/logo/text_logo.svg" alt="log" />
          <S.LoginTextWrapper>
            <div>러너펍 운영 솔루션</div>
            <div className="sub">원활한 매장 운영을 위한 최적의 파트너</div>
          </S.LoginTextWrapper>
        </S.LoginLeftContentWrapper>
      </S.LoginLeftWrapper>
      <S.FormWrapper>
        <S.LoginTextWrapper>
          <div>로그인</div>
          <div className="sub">
            러너러너앱과 동일한 계정으로 로그인 해주세요.
          </div>
        </S.LoginTextWrapper>
        <S.LoginInputWrapper>
          <S.LoginInput>
            <div>아이디</div>
            <input
              type="text"
              placeholder="아이디"
              value={textId}
              onChange={(e) => setTextId(e.target.value)}
            />
          </S.LoginInput>
          <S.LoginInput>
            <div>비밀번호</div>
            <input
              type={pwView ? "text" : "password"}
              placeholder="비밀번호"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSellerLogin();
                }
              }}
            />
            <img
              src={
                pwView
                  ? "/image-web/login/pw-view.svg"
                  : "/image-web/login/pw-not-view.svg"
              }
              onClick={() => setPwView(!pwView)}
              alt="view"
            />
          </S.LoginInput>
        </S.LoginInputWrapper>
        <S.LoginButton onClick={() => handleSellerLogin()}>
          로그인
        </S.LoginButton>
        <S.LoginOtherLoginWRapper>
          <S.LoginBorderWrapper>
            <S.LoginBorder />
            <div>또는</div>
            <S.LoginBorder $isRotate />
          </S.LoginBorderWrapper>
          <div>다른 계정으로 로그인</div>
          <S.LoginOtherLoginButtonWrapper>
            <img
              src="/image-web/login/naver.svg"
              alt="naver"
              onClick={handleNaverLogin}
            />
            <img
              src="/image-web/login/apple.svg"
              alt="apple"
              onClick={handleAppleLogin}
            />
          </S.LoginOtherLoginButtonWrapper>
        </S.LoginOtherLoginWRapper>
      </S.FormWrapper>
    </S.Wrapper>
  );
};

export default Login;
